import AnimationProcessing from 'components/animations/processing'
import CancelIcon from 'components/icons/cancel/'
import FouSelect from 'components/form/fou-select/'
import Methods from 'src/pages/promotions/components/promo-select-fonts/script/methods/methods'
import TrashIcon from 'components/icons/trash/'
import isEqual from 'lodash/isEqual'
import { CUSTOM_PACKAGE, FAMILY_PACKAGE, SINGLE_STYLE } from 'src/utils/constants/common'
import { mapGetters } from 'vuex'
import { FouSelectObject } from 'src/utils/objects/fou-select'

export default {
  name: 'promo-select-fonts',

  components: {
    AnimationProcessing,
    CancelIcon,
    FouSelect,
    TrashIcon
  },
  data () {
    return {
      allPacks: [],
      allStyles: [],
      disableFontSelectField: '',
      familyCustomPacks: [],
      fontFamilies: FouSelectObject(),
      fontSelect: FouSelectObject(),
      fontSelectLoaded: false,
      isChecked: false,
      isList: false,
      isSearch: false,
      isTickFamilyRemoved: false,
      isViewAllAddBtnDisable: false,
      onlySingleStylePack: [],
      searchedFamilies: [],
      selectFontOptions: [
        { name: 'Specific Fonts', selectId: '2a' },
        { name: 'All fonts in my library', selectId: '1a' }
      ],
      selectedList: [],
      stylePacks: [],
      tickedFamilies: [],
      viewAllTickedFamilesIdArr: [],
      skuLimitReached: false,
    }
  },
  props: {
    // New code
    isEditPromotion: {
      type: Boolean,
      default: false
    },
    // end
    isSetAllFont: {
      type: Function,
      default: () => {}
    },
    allFontsKey: {
      type: String,
      default: ''
    },
    checkedAllowedPackages: {
      type: String,
      default: ''
    },
    // for Edit Promo
    editPromotionTickedFamilies: {
      type: Array,
      default: () => ([])
    },
    isDisableCheckbox: {
      type: Function,
      default: () => ({})
    },
    isStyleNotSelectedError: {
      type: Boolean,
      default: false
    },
    setStyleNotSelected: {
      type: Function,
      default: () => ({})
    },
    isScheduledPromotion: {
      type: Boolean,
      default: false
    },
    secretCodePresent: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.setFontSelectOptions()
    this.fontSelectLoaded = true
    // For only Edit Promotion set fonts selected dropdown
    if (this.isEditPromotion) {

      this.setFontSelectValues({
        label: isEqual(this.allFontsKey, 'Y') ? 'All fonts in my library' : 'Specific Fonts',
        value: isEqual(this.allFontsKey, 'Y') ? '1a' : '2a'
      })

      this.selectedList = this.editPromotionTickedFamilies.map(({ familyName, familyId }) => ({ value: String(familyId), label: familyName }))
      const familyIds = this.editPromotionTickedFamilies.map((item) => String(item.familyId))
      if (familyIds.length > 0) {
        this.$store.dispatch('promotions/getTaggedFamilies', { familyIds }).then((taggedFamilyData) => {
          this.isChecked = true
          let savedStylePacks = [] // Initaializing the already saved style packs
          let savedCustomFamilyPacks = [] // Initaializing the already saved custom family packs
          this.editPromotionTickedFamilies.forEach((data) => {
            this.addCheckedPacksInTaggedFamiliesEditPromotion(data)
            const customFamilyPacksArr = data.addSkus.filter((item) => item.skuType !== SINGLE_STYLE)
            const stylePacksArr = data.addSkus.filter((item) => item.skuType === SINGLE_STYLE)
            // When Only All Packs or All Styles are true
            if (data.allPackages || data.allStyle) {
              // When All Packs and All Styles are true
              if (data.allPackages && data.allStyle) {
                savedStylePacks = this.setEditPromotionPageStateData(savedStylePacks, stylePacksArr)
                savedCustomFamilyPacks = this.setEditPromotionPageStateData(savedCustomFamilyPacks, customFamilyPacksArr)
                this.allPacks.push(`allPacks-${data.familyId}`)
                return this.allStyles.push(`allStyles-${data.familyId}`)
              }
              // When only All Packs is true
              if (data.allPackages) {
                savedStylePacks = this.setEditPromotionPageStateData(savedStylePacks, stylePacksArr)
                savedCustomFamilyPacks = this.setEditPromotionPageStateData(savedCustomFamilyPacks, customFamilyPacksArr)
                return this.allPacks.push(`allPacks-${data.familyId}`)
              }
              // When only All Styles is true
              savedStylePacks = this.setEditPromotionPageStateData(savedStylePacks, stylePacksArr)
              savedCustomFamilyPacks = this.setEditPromotionPageStateData(savedCustomFamilyPacks, customFamilyPacksArr)
              return this.allStyles.push(`allStyles-${data.familyId}`)
            }
            // When only singleStyle is available in family
            if (isEqual(data.addSkus.length, 1) && this.isEditSingleStyleFamily(taggedFamilyData, String(data.familyId))) {
              return this.onlySingleStylePack.push(String(data.addSkus[0].skuId))
            }
            savedStylePacks = this.setEditPromotionPageStateData(savedStylePacks, stylePacksArr)
            savedCustomFamilyPacks = this.setEditPromotionPageStateData(savedCustomFamilyPacks, customFamilyPacksArr)
          })
          // Assign Values
          this.stylePacks = savedStylePacks
          this.familyCustomPacks = savedCustomFamilyPacks
          this.tickedFamilies = this.editPromotionTickedFamilies.map(({ familyId, familyName }) => ({ id: String(familyId), familyName }))
          this.viewAllTickedFamilesIdArr = this.editPromotionTickedFamilies.map(({ familyId }) => (String(familyId)))
        })
      }
    }
  },

  methods: {
    ...Methods,
    setListToFalse () {
      this.isList = false
    },
    isEditSingleStyleFamily (taggedFamilyData, selectedFamilyId) {
      const selectedFamilyArr = taggedFamilyData.filter((data) => isEqual(data.id, selectedFamilyId))
      return isEqual(selectedFamilyArr.length, 1) && isEqual(selectedFamilyArr[0].skus.length, 1)
    },
    setEditPromotionPageStateData (savedPacksArr, allPacksArr) {
      return [...savedPacksArr, ...allPacksArr.map((item) => String(item.skuId))]
    },
    isFamilyCustomPackAvailable (data) {
      if (data.length !== 0) {
        const packIdx = data.findIndex(data => (isEqual(data.packageType, CUSTOM_PACKAGE) || isEqual(data.packageType, FAMILY_PACKAGE)))
        return packIdx > -1
      }

      return false
    },
    isSingleStylePackAvailable (data) {
      if (data.length !== 0) {
        const singlePackIdx = data.findIndex(data => (isEqual(data.packageType, SINGLE_STYLE)))
        return singlePackIdx > -1
      }

      return false
    },
    setSelectedStyles ({ skus, id }, packInfo) {
      if (this.isStyleNotSelectedError) { this.setStyleNotSelected() }
      const allFamilyCustomPacks = skus.filter((item) => !isEqual(item.packageType, SINGLE_STYLE))
      const singleStylePacks = skus.filter((item) => isEqual(item.packageType, SINGLE_STYLE))
      const getCurrentTaggedFamilies = this.taggedFamilies.find((item) => isEqual(item.id, id)) || [] // This Object is used when user unselect anyone all styles or all packs

      let selectedFamilyCustomPacks;
      if (isEqual(packInfo, 'allPacks')) {
        if (this.allPacks.includes(`allPacks-${id}`)) {
          selectedFamilyCustomPacks = allFamilyCustomPacks;
        } else {
          selectedFamilyCustomPacks = [];
        }
      } else {
        selectedFamilyCustomPacks = allFamilyCustomPacks.filter(({ skuId }) => this.familyCustomPacks.includes(skuId));
      }

      let selectedSingleStylePacks;
      if (isEqual(packInfo, 'allStyles')) {
        if (this.allStyles.includes(`allStyles-${id}`)) {
          selectedSingleStylePacks = singleStylePacks;
        } else {
          selectedSingleStylePacks = [];
        }
      } else {
        selectedSingleStylePacks = singleStylePacks.filter(({ skuId }) => this.stylePacks.includes(skuId));
      }

      // When all the single style packs are selected then All Styles checkbox should be checked
      if (isEqual(singleStylePacks.length, selectedSingleStylePacks.length) && !this.allStyles.includes(`allStyles-${getCurrentTaggedFamilies.id}`)) {
        this.allStyles = [...this.allStyles, `allStyles-${getCurrentTaggedFamilies.id}`]
      }

      // When all the custom packs & family packd are selected then All Packs checkbox should be checked
      if (isEqual(allFamilyCustomPacks.length, selectedFamilyCustomPacks.length) && !this.allPacks.includes(`allPacks-${getCurrentTaggedFamilies.id}`)) {
        this.allPacks = [...this.allPacks, `allPacks-${getCurrentTaggedFamilies.id}`]
      }

      // For only All Styles and All Packs checkbox selected or unselected
      if (isEqual(packInfo, 'allPacks')) {
        this.familyCustomPacks = isEqual(selectedFamilyCustomPacks.length, 0)
          ? this.familyCustomPacks.filter((skuId) => (getCurrentTaggedFamilies.checkedPacksArr.findIndex((item) => item.skuId === skuId) <= -1)) // when user unselect the all Packs
          : [...new Set([...this.familyCustomPacks, ...allFamilyCustomPacks.map((item) => item.skuId)])] // when user select the all Packs
      }

      if (isEqual(packInfo, 'allStyles')) {
        this.stylePacks = isEqual(selectedSingleStylePacks.length, 0)
          ? this.stylePacks.filter((skuId) => (getCurrentTaggedFamilies.checkedPacksArr.findIndex((item) => item.skuId === skuId) <= -1)) // when user unselect the all Styles
          : [...new Set([...this.stylePacks, ...singleStylePacks.map((item) => item.skuId)])] // when user select the all Styles
      }

      // When isAllStyles is true, and user unselect one of the single style
      if (isEqual(packInfo, 'singleStyle') && getCurrentTaggedFamilies.isAllStyles) {
        this.allStyles = this.allStyles.filter((allStyleId) => allStyleId !== `allStyles-${getCurrentTaggedFamilies.id}`)
      }

      // // When isAllPacks is true, and user unselect one of the packs
      if (['customPack', 'familyPack'].includes(packInfo) && getCurrentTaggedFamilies.isAllPacks) {
        this.allPacks = this.allPacks.filter((allPacksId) => allPacksId !== `allPacks-${getCurrentTaggedFamilies.id}`)
      }

      // Code to save selected all Styles and all Packs in store
      this.$store.commit('promotions/addCheckedPacksInTaggedFamilies', {
        checkedPacksArr: [...selectedFamilyCustomPacks, ...selectedSingleStylePacks],
        selectedFamilyId: id,
        isAllPacks: this.allPacks.includes(`allPacks-${id}`),
        isAllStyles: this.allStyles.includes(`allStyles-${id}`)
      })
      this.getAllSkus()
    },
    getAllSkus () {
      let checkedPacksArr = this.$store.state.promotions.taggedFamilies
      .map(family => {
        if (!family.checkedPacksArr) {
          return [];
        }
        let addSkus = family.checkedPacksArr
        return addSkus;
      })
      .reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);
      this.skuLimitReached = checkedPacksArr.length > 100;
    },
    // Add checked packs in tagged families
    addCheckedPacksInTaggedFamiliesEditPromotion (data) {
      return this.$store.commit('promotions/addCheckedPacksInTaggedFamilies', {
        checkedPacksArr: data.addSkus.map((item) => ({
          skuId: String(item.skuId),
          description: item.skuName,
          packageType: item.skuType
        })),
        selectedFamilyId: String(data.familyId),
        isAllPacks: data.allPackages,
        isAllStyles: data.allStyle
      })
    },
    // Method to set only single style pack in family
    setSingleStylePack (data) {
      if (this.isStyleNotSelectedError) { this.setStyleNotSelected() }
      const isSingleStyleAddInModel = this.onlySingleStylePack.includes(data.skus[0].skuId)
      this.$store.commit('promotions/addCheckedPacksInTaggedFamilies', {
        checkedPacksArr: isSingleStyleAddInModel ? data.skus : [],
        selectedFamilyId: data.id,
        isAllPacks: false,
        isAllStyles: false
      })
      this.getAllSkus()
    },
    // Method to remove the tagged family
    removeFamily (id) {
      if (this.isStyleNotSelectedError) { this.setStyleNotSelected() }
      this.$store.commit('promotions/updateTaggedFamilies', id)
      this.removeTickFamily(id)
      this.getAllSkus()
      this.isTickFamilyRemoved = false
    },
    // Method to remove the error family
    removeErrorFamily (familyId) {
      this.$store.commit('promotions/updateTaggedErrorFamilies', familyId)
      return this.removeTickFamily(familyId)
    },
    setActiveFontSelectValue () {
      return isEqual(this.allFontsKey, 'Y') ? 'All fonts in my library' : 'Specific Fonts'
    }
  },

  computed: {
    ...mapGetters('promotions', {
      spinnerTaggedFamilies: ['uploadingTaggedFamilies'],
      taggedFamilies: ['taggedFamiliesList'],
      taggedErrorFamilies: ['taggedErrorFamiliesList'],
      loadingTaggedFamilies: ['uploadingTaggedFamilies']
    }),
    addButtonToggle () {
      return isEqual(this.viewAllTickedFamilesIdArr.length, 0)
    },
    getColumnClass () {
      return ([1, 2].includes(this.searchedFamilies.length)) ? this.$style.columnCountAuto : this.$style.columnCount3
    },
    // To set list of disabled options
    setDisabledOptionsList () {
      if (!isEqual(this.editPromotionTickedFamilies.length, 0) && !this.isScheduledPromotion) {
        return this.editPromotionTickedFamilies.map((data) => String(data.familyId))
      }
      return []
    }
  }
}
